import React, { Component } from 'react'
import { TableComp } from 'sz-react-utils-lite'
import { connect } from 'react-redux'
import {
  countryIds,
  defaultLogo,
  DefaultTablePagination,
  filterOption,
  InputBox, searchByTeam
} from '../../components/_utils/appUtils'
import { ColumnWidth } from '../WebComponent/columnWidth'
import { getAgentPerformanceReportFxn } from './actions'
import { Avatar, Col, Icon, notification, Row, Select, Tooltip } from 'antd'
import { getUdaanFilterFxn } from '../dashboard/actions/dashboardAction'
import S from 'string'
import CityJson from '../../assets/jsonFiles/indiaCities.json'
import lodash from 'lodash'
import _ from 'lodash'
import StateJson from '../../assets/jsonFiles/states.json'
import CountryJson from '../../assets/jsonFiles/countries.json'
import AgentTypeheadComponent from '../../components/_utils/AgentTypeheadComponent'
import { getMarketingTeamFxn, getSingleUser } from '../users/actions/user'
import ScheduleMeetingDrawer from './scheduleMeetingListModal'
import MobileEmailInfo from '../../components/commonComponents/mobileEmailInfo'
import { listAllCountries } from '../countries/actions/countries'
import UpdateMarketingUserDrawer from './updateMarketingUserDrawer'
import UpdateAllMarketingUserDrawer from './updateAllMarketingUserDrawer'

let { Option } = Select
const renderCountryColumn = (countryKey, allowedState, showUpdateMarketingUserDrawer, marketingCounrtiesArr) => (item, record) => {
  const matchedCountry = record.records.find(
    (r) => r.countryId === countryIds[countryKey]
  )
  const matchedMarketingUsers = record.marketingUsers.filter(
    user => (user.countryId == countryIds[countryKey] && user.university == 'Public')
  )
  const cyprusMarketingUsers = record.marketingUsers.filter(
    user => (user.countryId == countryIds.cyprus)
  )
  const editBtn = (
    <Icon
      type='edit'
      style={{ marginLeft: 8, cursor: 'pointer', color: '#1890ff' }}
      onClick={showUpdateMarketingUserDrawer(record.agentName || '--', record.companyName || '--', record.agentId || '')}
    />
  )

  return (
    <ColumnWidth width={80}>
      {matchedCountry ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {matchedCountry.data.map((d, index) => (
            <div
              key={index}
              style={{
                flex: '1 1 calc(50% - 8px)',
                minWidth: 100,
                border: '1px dashed #d9d9d9',
                borderRadius: 8,
                padding: '10px 12px',
                background: '#fafafa',
                textAlign: 'center'
              }}
            >
              <div
                style={{
                  fontSize: 12,
                  color: '#1890ff',
                  fontWeight: 500,
                  marginBottom: 6,
                  textTransform: 'capitalize'
                }}
              >
                {d.status}
              </div>
              <div style={{ fontSize: 16, fontWeight: 600 }}>{d.count}</div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ color: '#ccc', textAlign: 'center' }}>-</div>
      )}

      {matchedMarketingUsers.length > 0 && matchedMarketingUsers[0].name && (
        <div
          style={{
            marginTop: 12,
            textAlign: 'center',
            fontSize: 13,
            color: matchedMarketingUsers[0].block ? 'red' : '#595959',
            font: 'bold',
            fontStyle: 'italic'
          }}
        >
          {matchedMarketingUsers[0].name}
          {
            allowedState && allowedState.length
              ? (allowedState.includes(record.state) && marketingCounrtiesArr.includes(countryIds[countryKey]) ? editBtn : null)
              : (marketingCounrtiesArr.includes(countryIds[countryKey]) ? editBtn : null)
          }
        </div>
      )}
      {countryKey === 'cyprus' && cyprusMarketingUsers.length > 0 && (
        <div style={{ marginTop: 12, textAlign: 'center' }}>
          {lodash.uniqBy(cyprusMarketingUsers, 'name').map((user, index) =>
            user.name ? (
              <div
                key={index}
                style={{
                  fontSize: 13,
                  color: '#595959',
                  fontStyle: 'italic'
                }}
              >
                {user.name}
              </div>
            ) : null
          )}
        </div>
      )}
    </ColumnWidth>

  )
}

class AgentPerformanceReport extends Component {
  componentDidMount() {
    this.loadUdaanFilter()
    this.loadUserList()
    this.loadCountry()
    // this.loadCountry()
    this.getSingleUserFxn()
  }

  constructor(props) {
    super(props)
    this.state = {
      visibleDepositDrawer: false,
      selectedUdaan: undefined,
      udaanFilter: [],
      allCountries: [],
      filteredCities: [],
      countryName: '',
      allStates: [],
      stateName: [],
      cityName: [],
      agentId: '',
      total: 0,
      marketingUserList: [],
      marketingUserId: '',
      visibleMeetingModal: {
        visible: false,
        agentId: ''
      },
      applicationCountryId: [],
      searchByTeam: 'assignedToTeam',
      allowedState: '',
      showUpdateMarketingDrawer: false,
      selectedAgentId: '',
      countryId: '',
      agentIdArr: [],
      marketingCountriesArr: []
    }
    this.tableRef = React.createRef()
  }

  events = {
    reload: () => {
      this.tableRef.current.reload()
    },
    showDrawer: (agentId) => {
      this.setState({
        visibleMeetingModal:
          { visible: true, agentId: agentId }
      })
    },
    hideDrawer: () => {
      this.setState({
        visibleMeetingModal: {
          visible: false,
          agentId: 'agentId'
        }
      })
      // this.events.reload()
    },
    hideMarketingUserDrawer: () => {
      this.setState({
        showUpdateMarketingDrawer: false
      })
      this.events.reload()
    },

    hideAllMarketingUserDrawer: () => {
      this.setState({
        showUpdateAllMarketingDrawer: false
      })
      this.events.reload()
    },

    showAllMarketingUserDrawer: () => {
      this.setState({
        showUpdateAllMarketingDrawer: true
      })
    }
  }

  apiRequest = (params) => {
    const { dispatch } = this.props
    return new Promise(async (resolve) => {

      if (this.state.countryName) {
        params.countryName = this.state.countryName
      }
      if (this.state.stateName && this.state.stateName.length && this.state.stateName.length > 0) {
        params.stateName = this.state.stateName
      }
      if (this.state.cityName) {
        params.cityName = this.state.cityName
      }
      if (this.state.selectedUdaan) {
        params.udaanName = this.state.selectedUdaan
      }
      if (this.state.agentId) {
        params.agentId = this.state.agentId
      }
      if (this.state.applicationCountryId) {
        params.applicationCountryId = this.state.applicationCountryId
      }
      if (this.state.searchByTeam == 'assignedToTeam' && this.state.marketingUserId) {
        params.searchByTeam = this.state.searchByTeam
        params.marketingUserId = this.state.marketingUserId
      }
      if (this.state.searchByTeam == 'notAssignedToTeam') {
        params.searchByTeam = this.state.searchByTeam
        params.marketingUserList = this.state.marketingUserList
      }
      if (params.countryName && params.stateName) {
        const { data } = await dispatch(getAgentPerformanceReportFxn(params))

        if (data && data.data && Array.isArray(data.data)) {
          const agentIdArr = data.data.map(item => item.agentId).filter(Boolean)
          this.setState({ agentIdArr })
        }
        this.setState({ total: data.total, allowedState: data.allowedState || '' })
        resolve(data)
      } else {
        resolve([])
      }
    })
  }

  loadUdaanFilter = async () => {
    try {
      const udaanFilter = await getUdaanFilterFxn()
      this.setState((prev) => ({
        udaanFilter,
        selectedUdaan: prev.selectedUdaan || (udaanFilter[0] && udaanFilter[0].value)
      }))
    } catch (error) {
      console.error('Failed to load udaan filter', error)
    }
  }

  loadUserList = async () => {
    let data = await this.props.dispatch(getMarketingTeamFxn({ marketingFor: 'unizportal' }))
    if (data.users && data.users.length) {
      this.setState({ marketingUserList: data.users })
    }
  }

  LoadAllCountry = () => {
    return CountryJson
  }

  LoadState = () => {
    if (this.state.countryId) {
      return lodash.filter(StateJson, item => {
        return item.country_id == this.state.countryId
      })
    } else {
      return []
    }
  }


  LoadCityByIds = (stateIds) => {
    if (Array.isArray(stateIds) && stateIds.length > 0) {
      this.setState({
        filteredCities: lodash.filter(CityJson, (item) => stateIds.includes(item.state_id))
      })
    } else {
      this.setState({
        filteredCities: []
      })
    }
  }

  loadCountry = async () => {
    let filters = {
      results: 100,
      count: 100
    }
    let { data } = await this.props.dispatch(listAllCountries(filters))
    this.setState({
      allCountries: data
    })
  }

  getSingleUserFxn = async () => {
    if (this.props.currentUser._id) {
      let filters = { userId: this.props.currentUser._id }
      let data = await this.props.dispatch(getSingleUser(filters))
      let marketingArr = data.marketingCountries || []

      let marketingCountriesArr = marketingArr.map(item => item.countryId)
      this.setState({
        marketingCountriesArr: marketingCountriesArr
      })
    }
  }


  searchFxn = async () => {
    let { applicationCountryId, searchByTeam } = this.state
    if (!this.state.countryName || !Array.isArray(this.state.stateName) || this.state.stateName.length === 0) {
      notification.warning({ message: 'Please choose country and state' })
      return
    }
    if (searchByTeam == 'notAssignedToTeam' && (!applicationCountryId || (applicationCountryId && !applicationCountryId.length))) {
      notification.warning({ message: 'Please choose atleast 1  application country.' })
      return
    }
    this.events.reload()
  }

  clearFxn = async () => {
    this.setState({
      countryId: '',
      countryName: '',
      stateId: [],
      stateName: [],
      cityName: [],
      selectedUdaan: undefined,
      agentId: '',
      marketingUserId: '',
      total: 0
    })
    setTimeout(() => {
      this.events.reload()
    }, 200)
  }


  render() {
    const columns = [
      {
        title: '#',
        key: '_id',
        dataIndex: '_id',
        width: 50,
        render: (ite, record, index) => index + 1
      },
      {
        title: 'Agent Name',
        key: 'agentName',
        sorter: true,
        dataIndex: 'agentName',
        searchTextName: 'agentName',
        width: 300,
        render: (item, record) => {
          let logoUrl = record && record.logo && record.logo.url ? record.logo.url : defaultLogo
          let data = {
            _id: record.agentId,
            userType: 'agent'
          }
          return (
            <ColumnWidth width={300}>
              <div className={'d-flex'}>
                <div style={{ width: 60, marginRight: 10 }}>
                  <Avatar src={logoUrl} size={55} />
                </div>
                <div>
                  <strong>{item}</strong>
                  <span style={{ color: '#888' }}>({record.companyName})</span><br />
                  <strong>Email: </strong><MobileEmailInfo data={data} type={'email'} value={record.email} /><br />
                  <strong>Mobile: </strong><MobileEmailInfo data={data} type={'mobile'} value={record.mobile} /><br />
                  <strong>Address: </strong>
                  {record.address}, {record.city}, {record.state}
                </div>
              </div>

            </ColumnWidth>
          )
        }
      },
      {
        title: 'UK',
        key: 'uk',
        dataIndex: 'uk',
        width: 100,
        render: renderCountryColumn(
          'uk',
          this.state.allowedState,
          (agentName, companyName, agentId) => () => {
            this.setState({
              showUpdateMarketingDrawer: true,
              agentName: agentName || '--',
              companyName: companyName,
              selectedAgentId: agentId,
              countryId: countryIds.uk
            })
          },
          this.state.marketingCountriesArr
        )
      },
      {
        title: 'CANADA',
        key: 'canada',
        dataIndex: 'canada',
        width: 100,
        render: renderCountryColumn('canada',
          this.state.allowedState,
          (agentName, companyName, agentId) => () => {
            this.setState({
              showUpdateMarketingDrawer: true,
              agentName: agentName || '--',
              companyName: companyName,
              selectedAgentId: agentId,
              countryId: countryIds.canada
            })
          },
          this.state.marketingCountriesArr
        )
      },
      {
        title: 'GERMANY',
        key: 'germany',
        dataIndex: 'germany',
        width: 100,
        render: renderCountryColumn('germany',
          this.state.allowedState,
          (agentName, companyName, agentId) => () => {
            this.setState({
              showUpdateMarketingDrawer: true,
              agentName: agentName || '--',
              companyName: companyName,
              selectedAgentId: agentId,
              countryId: countryIds.germany
            })
          },
          this.state.marketingCountriesArr
        )
      },
      {
        title: 'USA',
        key: 'usa',
        dataIndex: 'usa',
        width: 100,
        render: renderCountryColumn('usa',
          this.state.allowedState,
          (agentName, companyName, agentId) => () => {
            this.setState({
              showUpdateMarketingDrawer: true,
              agentName: agentName || '--',
              companyName: companyName,
              selectedAgentId: agentId,
              countryId: countryIds.usa
            })
          },
          this.state.marketingCountriesArr
        )
      },
      {
        title: 'CYPRUS',
        key: 'cyprus',
        dataIndex: 'cyprus',
        width: 100,
        render: renderCountryColumn('cyprus',
          this.state.allowedState,
          (agentName, companyName, agentId) => () => {
            this.setState({
              showUpdateMarketingDrawer: true,
              agentName: agentName || '--',
              companyName: companyName,
              selectedAgentId: agentId,
              countryId: countryIds.cyprus
            })
          },
          this.state.marketingCountriesArr
        )
      },
      {
        title: 'AUSTRALIA',
        key: 'australia',
        dataIndex: 'australia',
        width: 100,
        render: renderCountryColumn('australia',
          this.state.allowedState,
          (agentName, companyName, agentId) => () => {
            this.setState({
              showUpdateMarketingDrawer: true,
              agentName: agentName || '--',
              companyName: companyName,
              selectedAgentId: agentId,
              countryId: countryIds.australia
            })
          },
          this.state.marketingCountriesArr
        )
      },
      {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        width: 120,
        render: (item, record) => {
          return (
            <>
              <Tooltip title={'View Meeting Records'}>
                <a className='btn btn-default roundNew sm' onClick={() => {
                  this.events.showDrawer(record.agentId)
                }}>
                  <Icon type='eye' /> Meetings
                </a>
              </Tooltip>
            </>
          )
        }
      }
    ]

    return (
      <div className='row mt-4'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='table-head d-flex align-items-center'>
              <h5>Agent Performance Report ({this.state.total})</h5>
              <div className='search-box-table'>

              </div>
            </div>
            <div className='card-body table-responsive'>
              <Row gutter={12} className={'filter_box'}>

                <Col span={6}>
                  <InputBox title={'Search by agent'}>
                    <AgentTypeheadComponent
                      key={this.state.agentId}
                      agentId={this.state.agentId}
                      dispatch={this.props.dispatch}
                      customStyle={''}
                      onSelect={item => {
                        this.setState({ agentId: item })
                      }}
                    />
                  </InputBox>
                </Col>

                <Col span={6}>
                  <InputBox title={'Search by udaan'}>
                    <Select
                      value={this.state.selectedUdaan || undefined}
                      onChange={(e) => this.setState({ selectedUdaan: e })}
                      style={{ minWidth: 200 }}
                      placeholder='Select Udaan'
                      allowClear={true}
                    >
                      {this.state.udaanFilter && this.state.udaanFilter.length > 0 &&
                      this.state.udaanFilter.map((item) => (
                        <Option value={item.value} key={item.value}>
                          <b>{S(item.value).humanize().s}</b>
                          {item.message ? <span> ({item.message})</span> : ''}
                        </Option>
                      ))}
                    </Select>
                  </InputBox>
                </Col>

                <Col span={6}>
                  <InputBox title={'Search By Team'}>
                    <Select
                      name='Search By Team'
                      filterOption={filterOption}
                      allowClear={true}
                      placeholder={'Search By Team'}
                      onChange={(e) => this.setState({ searchByTeam: e, marketingUserId: '' })}
                      value={this.state.searchByTeam || undefined}>
                      {searchByTeam.map((item, key) => {
                        return (
                          <Option value={item.id} key={key}>
                            {item.name}
                          </Option>
                        )
                      })}
                    </Select>
                  </InputBox>
                </Col>

                {this.state.searchByTeam == 'assignedToTeam' && <Col span={6}>
                  <InputBox title={`Search by marketing user (${this.state.marketingUserList.length})`}>
                    <Select
                      name='Select Marketing User'
                      filterOption={filterOption}
                      allowClear={true}
                      placeholder={'Select Marketing User'}
                      showSearch={true}
                      onChange={(e) => this.setState({ marketingUserId: e })}
                      value={this.state.marketingUserId || undefined}>
                      {this.state.marketingUserList && this.state.marketingUserList.length
                        ? this.state.marketingUserList.map((item, key) => {
                          let newName = `${item.name} (${item.email})`
                          return (
                            <Option value={item._id} key={key}>
                              {newName}
                            </Option>
                          )
                        })
                        : null}
                    </Select>
                  </InputBox>
                </Col>}

                <Col span={6}>
                  <InputBox title={'Search by Application Country'}>
                    <Select
                      mode='multiple'
                      name='Application Country'
                      onChange={(x) => {
                        this.setState({
                          applicationCountryId: x
                        })
                      }}
                      filterOption={filterOption}
                      allowClear
                      showSearch
                      placeholder='Select Application Country'
                      value={this.state.applicationCountryId || []}
                      style={{ minWidth: 200 }}
                    >
                      {this.state.allCountries.map((item) => (
                        <Option value={item._id} key={item._id}>
                          {item.countryName}
                        </Option>
                      ))}
                    </Select>
                  </InputBox>
                </Col>


                <Col span={6}>
                  <InputBox title={'Search by country'}>
                    <Select
                      name='Country'
                      onChange={(x) => {
                        let findCountry = _.find(CountryJson, (item) => {
                          return item.id == x
                        })
                        const allStates = this.LoadState()
                        if (findCountry) {
                          this.setState({
                            countryId: findCountry.id,
                            countryName: findCountry.name,
                            allStates,
                            stateName: [],
                            cityName: [],
                            allCities: []
                          })
                        }
                      }}
                      filterOption={filterOption}
                      allowClear
                      showSearch
                      placeholder='Select Country'
                      value={this.state.countryName || undefined}
                      style={{ minWidth: 200 }}
                    >
                      {CountryJson.map((item) => (
                        <Option value={item.id} key={item.id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </InputBox>
                </Col>

                <Col span={6}>
                  <InputBox title={'Search by state'}>
                    <Select
                      mode='multiple'
                      name='State'
                      onChange={(selectedIds) => {
                        const selectedStates = this.LoadState().filter((item) =>
                          selectedIds.includes(item.id)
                        )
                        const stateNames = selectedStates.map((item) => item.name)
                        const allCities = this.LoadCityByIds(selectedIds) // Updated below

                        this.setState({
                          stateId: selectedIds,
                          stateName: stateNames,
                          allCities,
                          cityName: []
                        })
                      }}
                      filterOption={filterOption}
                      allowClear
                      showSearch
                      placeholder='Select State'
                      value={this.state.stateId || []}
                      style={{ minWidth: 200 }}
                    >
                      {this.LoadState().map((item) => (
                        <Option value={item.id} key={item.id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </InputBox>
                </Col>

                <Col span={6}>
                  <div className='input-box'>
                    <InputBox title={'Search by city'}>
                      {this.state.filteredCities.length > 0 ? (
                        <Select
                          mode='multiple'
                          allowClear
                          showSearch
                          placeholder='Select City'
                          filterOption={(input, option) =>
                            option.props.children.toLowerCase().includes(input.toLowerCase())
                          }
                          style={{ minWidth: 200 }}
                          value={this.state.cityName}
                          onChange={(value) => this.setState({ cityName: value })}
                        >
                          {this.state.filteredCities.map((item) => (
                            <Option value={item.name} key={item.name}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      ) : (
                        <Select
                          mode='tags'
                          style={{ minWidth: 200 }}
                          value={this.state.cityName}
                          onChange={(value) => this.setState({ cityName: value })}
                          tokenSeparators={[]}
                          placeholder='Enter or select cities'
                        >
                          {this.state.filteredCities.map((item) => (
                            <Option key={item.name} value={item.name}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </InputBox>
                  </div>
                </Col>


                <Col span={24}>
                  <div className={'btn_group'}>
                    {
                      this.state.cityName.length > 0 && this.state.stateName.length > 0 && this.state.countryName && this.state.total > 0 &&
                      <a className={'default_btn'} onClick={() => this.events.showAllMarketingUserDrawer()}>
                        Update all
                      </a>
                    }
                    <a className={'default_btn'} onClick={() => this.searchFxn()}>Search</a>
                    <a className={'default_btn'} onClick={() => this.clearFxn()}>Clear</a>
                  </div>
                </Col>
              </Row>
              <TableComp
                columns={columns}
                ref={this.tableRef}
                pagination={DefaultTablePagination()}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 1000 } }}
              />
            </div>
            {this.state.visibleMeetingModal.visible ?
              <ScheduleMeetingDrawer
                visible={this.state.visibleMeetingModal.visible}
                agentId={this.state.visibleMeetingModal.agentId}
                onClose={this.events.hideDrawer}
              /> : null}
            {this.state.showUpdateMarketingDrawer ?
              <UpdateMarketingUserDrawer
                dispatch={this.props.dispatch}
                visible={this.state.showUpdateMarketingDrawer}
                onClose={this.events.hideMarketingUserDrawer}
                agentName={this.state.agentName}
                companyName={this.state.companyName}
                agentId={this.state.selectedAgentId}
                countryId={this.state.countryId}
              /> : null}
            {this.state.showUpdateAllMarketingDrawer ?
              <UpdateAllMarketingUserDrawer
                dispatch={this.props.dispatch}
                visible={this.state.showUpdateAllMarketingDrawer}
                onClose={this.events.hideAllMarketingUserDrawer}
                agentIdArr={this.state.agentIdArr}
                marketingCounries={this.state.marketingCountriesArr}
              /> : null}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories,
  currentUser: global.currentUser
})

export default connect(mapStateToProps)(AgentPerformanceReport)
